export function normalizeLoginResponse(response) {
  if (response?.success) return response

  const accessToken = response?.access_token || response?.data?.access_token || ''
  const refreshToken = response?.refresh_token || response?.data?.refresh_token || ''
  const tokenType = response?.token_type || response?.data?.token_type || 'bearer'
  const user = response?.user || response?.data?.user || null

  if (!accessToken || !user) {
    return { success: false, message: response?.message || 'Authentication failed' }
  }

  return {
    success: true,
    data: {
      token: accessToken,
      access_token: accessToken,
      refresh_token: refreshToken,
      token_type: tokenType,
      user: {
        ...user,
        user_id: user?.user_id || user?.id || '',
        user_type: user?.user_type || user?.role || '',
      },
    },
  }
}
